export const SoftwareDB = [
    {
        id: 1,
        titulo: "SmartPath-Smart Pathology Plataform",
        meio: "INPI",
        link: "https://busca.inpi.gov.br/pePI/servlet/ProgramaServletController?Action=detail&CodPedido=30193&SearchParameter=PATHOLOGY%20PLATAFORM",
        data: "2019",
        text1: "BR 51 2020 002127 1",
        //text2: "No LINA trabalhamos com diversos SIS nas mais diversas áreas da saúde como por exemplo: <a href='jsdhk.html'>Sistemas de Apoio ao Ensino de Patologias Renais</a>, Sistema de Suporte a Detecção de Doenças Renais, Automatização do processo de modelagem de moléculas HLA, Auxílio a Elaboração de Avaliação Comportamental no Contexto Clínico e Descoberta de Conhecimento através de Métodos de Aprendizagem de Máquina aplicados a Base de Dados de compatibilidade HLA.",
        icon: "fa fa-file-code-o",
    },
    {
        id: 2,
        titulo: "Aplicativo para auxílio da Avaliação Comportamental baseado em Inteligência Artificial ",
        meio: "INPI",
        link: "https://busca.inpi.gov.br/pePI/servlet/ProgramaServletController?Action=detail&CodPedido=37469&SearchParameter=",
        data: "2022",
        text1: "BR 51 2022 003133 7 ",
        //text2: "asdksjldj kj lkajl",
        icon: "fa fa-file-code-o",
    },

    {
        id: 3,
        titulo: "OQCBFV - Modelo de Otimização da Quantidade de Clusters Baseado em Faixa de Valores dos atributos.",
        meio: "INPI",
        link: "https://busca.inpi.gov.br/pePI/servlet/ProgramaServletController?Action=detail&CodPedido=40830&SearchParameter=",
        data: "2023",
        text1: "BR 51 2023 002848 7 ",
        //text2: "asdksjldj kj lkajl",
        icon: "fa fa-file-code-o",
    },

    {
        id: 4,
        titulo: "HLA-API - API (Application Programming Interface) para Automatização do processo de modelagem de moléculas HLA.",
        meio: "INPI",
        link: "https://busca.inpi.gov.br/pePI/servlet/ProgramaServletController?Action=detail&CodPedido=42744&SearchParameter=",
        data: "2023",
        text1: "BR 51 2024 000530 7 ",
        //text2: "asdksjldj kj lkajl",
        icon: "fa fa-file-code-o",
    },

    {
        id: 5,
        titulo: "PREGest - Ferramenta auxílio aos profissionais de saúde na prestação de cuidados a gestantes com Pré- Eclâmpsia",
        meio: "INPI",
        link: "https://busca.inpi.gov.br/pePI/servlet/ProgramaServletController?Action=detail&CodPedido=42859&SearchParameter=",
        data: "2024",
        text1: " BR 51 2024 000644 3 ",
        //text2: "asdksjldj kj lkajl",
        icon: "fa fa-file-code-o",
    },

    {
        id: 6,
        titulo: " SIGest - Aplicação mobile para auxílio aos profissionais da saúde na assistência e tratamento médico de sífilis durante a gravidez ",
        meio: "INPI",
        link: "https://busca.inpi.gov.br/pePI/servlet/ProgramaServletController?Action=detail&CodPedido=43021&SearchParameter=",
        data: "2024",
        text1: "BR 51 2024 000807 1",
        //text2: "asdksjldj kj lkajl",
        icon: "fa fa-file-code-o",
    },

    {
        id: 7,
        titulo: "SICAS - Sistema de Controle de Animais Silvestres.",
        meio: "INPI",
        link: "https://busca.inpi.gov.br/pePI/servlet/ProgramaServletController?Action=detail&CodPedido=43172&SearchParameter=",
        data: "2024",
        text1: " BR 51 2024 000958 2 ",
        //text2: "asdksjldj kj lkajl",
        icon: "fa fa-file-code-o",
    }
    
  ];
  